import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import KAMPYLE_EVENT_DISPATCHER from './KAMPYLE_EVENT_DISPATCHER';
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';

  var eventSubscriptions;

  function init() {
    eventSubscriptions = {};
  }

  function getTriggerMessage(settings){
    var messageTemplate = KAMPYLE_CONSTANT.LOG_MESSAGES.TRIGGER_MESSAGE_TEMPLATE;
    messageTemplate = messageTemplate.replace("{{EVENT_NAME}}",settings.eventName)
      .replace("{{DATA}}",KAMPYLE_UTILS.getStrigifiedData(settings.data))
      .replace("{{CONTEXT}}",KAMPYLE_UTILS.getStrigifiedData(settings.context))
      .replace("{{OPTIONS}}",KAMPYLE_UTILS.getStrigifiedData(settings.options));
    if(settings.errorMessage){
      messageTemplate = messageTemplate.replace('{{STATUS}}',KAMPYLE_CONSTANT.LOG_STATUSES.FAILED);
      messageTemplate += KAMPYLE_CONSTANT.LOG_MESSAGES.ERROR_LOG_TEMPLATE.replace("{{ERROR_MESSAGE}}",settings.errorMessage);
    }
    else{
      messageTemplate = messageTemplate.replace('{{STATUS}}',KAMPYLE_CONSTANT.LOG_STATUSES.TRIGGERED);
    }
    return messageTemplate;
  }


  function getEventSubscriptions(eventName) {
    if (eventName && eventSubscriptions && eventSubscriptions[eventName]) {
      return eventSubscriptions[eventName];
    }
    else {
      return eventSubscriptions;
    }

  };

  var unsubscribe = function(eventName, callback) {
    if (!eventName || typeof eventName !== 'string' ||
        !callback || typeof callback !== 'function' ) {
      return false;
    }

    // Retrieve a list of current subscribers for eventName (if any)
    var subscribers = eventSubscriptions[eventName];

    if (typeof subscribers !== 'undefined') {
      // Add the given callback function to the end of the array with
      // eventSubscriptions for this event.
      var callbackIndex = subscribers.indexOf(callback);
      if (callbackIndex !== -1)
      {
        subscribers.splice(callbackIndex,1);
      }
    }

    return true;

  };

  var subscribe = function(eventName, callback) {
    if (!eventName || typeof eventName !== 'string' ||
        !callback || (typeof callback !== 'function' && typeof callback !== 'string') ) {
      return false;
    }
    // Retrieve a list of current subscribers for eventName (if any)
    var subscribers = eventSubscriptions[eventName];

    if (typeof subscribers === 'undefined') {
      // If no subscribers for this event were found,
      // initialize a new empty array
      subscribers = eventSubscriptions[eventName] = [];
    }

    // Add the given callback function to the end of the array with
    // eventSubscriptions for this event.
    var callbackIndex = subscribers.indexOf(callback);
    if (callbackIndex === -1) //Meaning doesn't exist already
    {
      subscribers.push(callback);
    }

    return true;
  };

  function appendDefaultEventParams(data) {
    data = data || {};
    var allData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    var defaultValues = {};
    if (allData) {
      defaultValues = {
        'accountId': allData.accountId,
        'websiteId':allData.websiteId,
        'enviroment':allData.region
      };
    }

    return Object.assign(data,defaultValues);
  }

  var trigger = function(eventName, data, context, options) {
    var subscribers = KAMPYLE_UTILS.getNestedPropertyValue(eventSubscriptions, eventName);
    var i, iMax;

    if (typeof subscribers === 'undefined' || subscribers === null) {
      // No list found for this event, return early to abort execution
      return false;
    }

    data = appendDefaultEventParams(data);


    // Ensure data is an array or is wrapped in an array,
    // for Function.prototype.apply use
    var dataAsArray = (data instanceof Array) ? data : [data];

    // Set a default value for `this` in the callback
    context = context || null;
    iMax = subscribers.length;
    for (i = 0;  i < iMax; i += 1) {
      if (typeof subscribers[i] === 'string') {
        KAMPYLE_UTILS.triggerCustomEvent(subscribers[i]);
      }
      else {
        try {
            subscribers[i].apply(context, [eventName].concat(dataAsArray));

            if(MDIGITAL_LOGGER.getLoggerStatus()){
              MDIGITAL_LOGGER.debug(getTriggerMessage({eventName:eventName,data:data,context:context,options:options,errorMessage:null}));
            }

        }catch(e)
        {

            if(MDIGITAL_LOGGER.getLoggerStatus()){
              MDIGITAL_LOGGER.error(getTriggerMessage({eventName:eventName,data:data,context:context,options:options,errorMessage:e.message}));
            }

            //TODO - add UDC tracking for it
            KAMPYLE_UTILS.showErrorStack(e);
            // We want to report to Digital analytics that the dispatching failed
            if (data) {
              data.errorMessage = e.message;
              data.errorStack = e.stack;
              if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":true,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
                MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError(data);
              }
            }

            // If we are in strict mode, errors should break the callback flow
            if (options && options.isStrictMode) {
                break;
            }
            continue;
        }
      }
    }

    return true;
  };

  var triggerError = function (errorData){
    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_EVENT_DISPATCHER_ERROR, errorData);
  };

  var subscribeMany = function(eventMapping) {
    for (var eventName in eventMapping) {
      if (eventMapping.hasOwnProperty(eventName)) {
        for (var i = 0; i < eventMapping[eventName].length; i++) {
          subscribe(eventName,eventMapping[eventName][i]);
        }
      }
    }
  };


  function subscribeOnce(eventName, callback) {

    // subscribers falls back to the entire subscription object
    var subscribers = getEventSubscriptions(eventName);
    if (!subscribers[eventName] || subscribers.indexOf(callback) === -1) {
      subscribe(eventName, callback);
    }
  }


  //public API
  export default {
    subscribe: subscribe,
    subscribeOnce: subscribeOnce,
    subscribeMany: subscribeMany,
    trigger: trigger,
    triggerError: triggerError,
    unsubscribe: unsubscribe,
    init: init,

    //for testing
    getEventSubscriptions: getEventSubscriptions,
    appendDefaultEventParams: appendDefaultEventParams
  }

